import { render, staticRenderFns } from "./SignUpPane.vue?vue&type=template&id=6b1c2ab6"
import script from "./SignUpPane.vue?vue&type=script&lang=js"
export * from "./SignUpPane.vue?vue&type=script&lang=js"
import style0 from "./SignUpPane.vue?vue&type=style&index=0&id=6b1c2ab6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports